module.exports = __webpack_public_path__ + "img/service-introduction-2.97c42505.png";